import { times } from 'lodash';
import moment, { Moment } from 'moment';
import React from 'react';
import { CalendarDay } from '../../../components/AbsenceCalendar/types';
import {
  calcAbsencesByDays,
  calcHolidaysByDay,
  calcWorkloadsByDays,
  workloadIncludesDay,
} from '../../../components/AbsenceCalendar/Utils';
import { TeamCalendarQuery } from '../../../__generated__/graphql';
import Table from './Table';
import { TeamCalendarFiltersType } from './Table/TeamCalendarFilters/types';

type Props = {
  fromDate: Moment;
  filterData: TeamCalendarFiltersType;
  employees: TeamCalendarQuery['me']['teamColleagues'];
};

export type AbsenceColleague = {
  id: string;
  name: string;
  avatarUrl: string | undefined;
  days: CalendarDay[];
};

const buildColleagues = (
  data: TeamCalendarQuery['me']['teamColleagues'],
  fromDate: Moment,
  toDate: Moment,
) => {
  const numOfDays = toDate.diff(fromDate, 'days');

  return data.map((collegue: TeamCalendarQuery['me']['teamColleagues'][0]) => {
    const absencesByDays = calcAbsencesByDays(collegue.absences2);

    const workloadsByDays = calcWorkloadsByDays(collegue.workloads, toDate);
    const holidaysByDay = calcHolidaysByDay(collegue.holidays);

    return {
      id: collegue.Id,
      name: collegue.Name,
      avatarUrl: collegue.avatar?.url ?? undefined,
      days: times(numOfDays + 1, (i) => {
        const day = moment(fromDate).add(i, 'days');
        const absences = absencesByDays.get(day.format('YYYYMMDD')) || [];
        const workload = workloadsByDays.get(day.format('YYYYMMDD'));
        const holiday = holidaysByDay.get(day.format('YYYYMMDD'));

        return {
          day: day,
          absences: absences,
          workday: (workload && workloadIncludesDay(workload, day)) || false,
          hover: false,
          holiday: holiday,
        };
      }),
    };
  });
};

const Content: React.FC<Props> = ({ fromDate, filterData, employees }) => {
  const toDate = fromDate.clone().endOf('month');

  const colleagues: AbsenceColleague[] = buildColleagues(
    employees,
    fromDate,
    toDate,
  );

  return (
    <Table
      fromDate={fromDate}
      toDate={toDate}
      colleagues={colleagues}
      filterData={filterData}
    />
  );
};

export default Content;
